<template>
    <div v-if="loading" class="loading-overlay">
      <div class="loading-box">
        <span :style="{padding: '0 2rem 0 0'}">Loading...</span>
        <CIcon type="loading" spin class="loading-icon" />
      </div>
    </div>
  </template>
  
  <script>
  import CIcon from "./CIcon.vue";

  export default {
    props: {
      loading: {
        type: Boolean,
        required: true,
      },
    },
    components: {
      CIcon
    },
  };
  </script>
  
  <style scoped>
  .loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5); /* Semi-transparent black background */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999; /* Ensure it appears above other elements */
  }
  
  .loading-box {
    background: white;
    padding: 15px 30px;
    border-radius: 12px; /* Rounded corners */
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1); /* Slight shadow for better visibility */
    display: flex;
    align-items: center;
  }
  
  .loading-icon {
    margin-right: 10px;
  }
  </style>
  